module.exports = __webpack_public_path__ + "img/p5.8a731fc0.png";